import { cn } from '@/lib/utils'

/**
 * Returns Tailwind CSS classes for interactive UI elements based on their active state
 * @param {Object} options - Configuration options
 * @param {boolean} options.isActive - Whether the element is in an active/selected state
 * @returns {string} Combined Tailwind CSS classes for styling the element
 */
export function useItemColors({ isActive }) {
  return cn(
    'dark:text-white/80 new-chat:text-white/80',
    'focus:outline-none focus:ring-0',
    'hover:bg-black/10 dark:hover:bg-white/15 new-chat:hover:bg-white/15',
    'hover:text-black/95 dark:hover:text-white new-chat:dark:hover-text-white',
    'active:bg-black/5 dark:active:bg-white/10 new-chat:active:bg-white/10',
    'focus:bg-black/10 dark:focus:bg-white/15 new-chat:focus:bg-white/15',
    isActive && [
      'bg-black/10 dark:bg-white/15 new-chat:bg-white/15',
      'font-semibold dark:text-white new-chat:text-white',
      'hover:bg-black/5 dark:hover:bg-white/15 new-chat:hover:text-white/15',
      'active:bg-black/10 dark:active:bg-white/5 new-chat:text-white/5',
    ],
  )
}
